export const defaultMaxResults = 50;

export enum filterId {
  query = 'query'
}
